import useApiActivityLog from "api/activity-log/use-api-activity-log";
import clsx from "clsx";
import { Content, Modal } from "components/modal";
import { useToast } from "contexts/toast";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";

import css from "./index.module.scss";

export const COOKIE_AUTH_SIGNUP_MODAL = "auth_signup_modal";

type Props = {
  onClose: () => void;
};

type ReplyType = {
  question: string;
  reply: string;
};

const LIST = [
  {
    options: [
      "Yes - I already have contacts, I just need their emails",
      "No - I need to find contacts first",
    ],
    question: "Do you already have a list of contacts to target?",
  },
  {
    options: [
      "For my business or personal use",
      "As an agency or consultant",
      "Integrate via API into my product",
    ],
    question: "How do you plan to use Anymail Finder?",
  },
  {
    options: ["Every month or more", "1–2 times per year"],
    question: "How often do you need to find emails?",
  },
  {
    options: ["0 - 1,000", "1,000 - 20,000", "20,000 or more"],
    question: "How many cold emails have you sent in the past 12 months?",
  },
];
const VERSION = "2025-06-30";

export const SignupModal = ({ onClose }: Props) => {
  const [reply, replySet] = useState<ReplyType[]>([]);
  const { addToast } = useToast();
  const { mutate: activityLogMutate } = useApiActivityLog();

  useEffect(() => {
    Cookies.remove(COOKIE_AUTH_SIGNUP_MODAL, {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });
  }, []);

  const current = LIST[reply.length];
  const onReply = (question: string, option: string) => {
    const updated = [...reply, { question, reply: option }];

    replySet(updated);

    if (updated.length === LIST.length) {
      activityLogMutate({
        description: JSON.stringify({ reply: updated, version: VERSION }),
        type: "auth_signup_modal",
      });
      onClose();
      addToast("Thank you!", { appearance: "success" });
    }
  };
  const onSkip = () => {
    activityLogMutate({
      description: JSON.stringify({ reply: [], version: VERSION }),
      type: "auth_signup_modal",
    });
    onClose();
  };

  return (
    <Modal overlayOpacity={90}>
      <Content className={css.content}>
        <div className={css.dot}>
          {LIST.map((_q, i) => (
            <div className={clsx(i <= reply.length && css.full)} key={i} />
          ))}
        </div>
        <div className={css.question}>{current.question}</div>
        <div className={css.optionGrid}>
          {current.options.map((option) => (
            <button
              className={css.optionItem}
              key={option}
              onClick={() => onReply(current.question, option)}
            >
              {option}
            </button>
          ))}
        </div>
        <button className={css.skip} onClick={onSkip}>
          Skip the survey
        </button>
      </Content>
    </Modal>
  );
};
